import { compose } from "recompose";
import { withRegistrationDatabase } from "../../../model/registration/RegistrationDatabase";
import withObservables from '@nozbe/with-observables';
import { Q } from '@nozbe/watermelondb';

export const ObserveHardwareVersionById = compose(
    withRegistrationDatabase,
    withObservables(['id'], ({ id, database }) => ({
      hardwareVersion: database.get('hardware_versions').findAndObserve(id)
    }))
  );
  
  export const ObserveHardwareVersionsList = compose(
    withRegistrationDatabase,
    withObservables([], ({ database }) => ({
      hardwareVersions: database.get('hardware_versions').query(Q.sortBy('created_at', Q.desc))
    }))
  );
  
  export const ObserveHardwareVersion = withObservables(['hardwareVersion'], ({ hardwareVersion }) => ({
    hardwareVersion,
  }));